import { EventCard } from '@/components/common/eventsByCategory/components/eventCarousel/components';
import { CategoryEventsSkeleton } from './components';
import { InfiniteScroll } from '@/components/common';
import { CalendarX2 } from 'lucide-react';

const CategoryEventsSection = ({
  subTitle,
  loading,
  loadMore,
  refreshing,
  data,
  hasMore,
}: any) => {
  const hasData = data && data.length > 0;

  return (
    <div className='min-h-screen'>
      {!loading ? (
        <>
          {subTitle && (
            <div className='flex items-center py-3 text-xl font-extrabold text-gray-800 after:ms-6 after:flex-1 after:border-t after:border-gray-200 dark:text-white dark:after:border-neutral-600'>
              {subTitle}
            </div>
          )}
          <div className='flex w-full flex-col pt-4 pb-8'>
            {hasData ? (
              <InfiniteScroll
                loadMore={loadMore}
                hasMore={hasMore}
                loader={refreshing ? <p>loading.....</p> : <></>}
              >
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6'>
                  {data?.map((obj: any, index: number) => (
                    <EventCard
                      event={obj}
                      key={index}
                      className='w-full'
                    />
                  ))}
                </div>
              </InfiniteScroll>
            ) : (
              <div className="flex flex-col items-center justify-center w-full py-16 px-4 text-center">
                <div className="bg-white p-4 rounded-full shadow-sm mb-4 dark:bg-neutral-800">
                  <CalendarX2 className="text-gray-400 dark:text-neutral-500" size={32} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 dark:text-white">
                  No events found
                </h3>
                <p className="mt-1 text-sm text-gray-500 max-w-xs mx-auto dark:text-neutral-400">
                  It looks like there aren't any events in this category right now. Check back later!
                </p>
              </div>
            )}
          </div>
        </>
      ) : (
        <CategoryEventsSkeleton />
      )}
    </div>
  );
};

export default CategoryEventsSection;
